<template>
  <div
    class="base-cell"
    :class="customClass"
    v-on="{...$listeners, ...hoverHandlers}"
  >
    <!--
      @slot Default Slot - hover property is returned
      @binding hover (Bool) property is returned on MouseEnter/MouseLeave
    -->
    <slot :hover="isHover" />
  </div>
</template>

<script>
import Hoverable from '../mixins/hoverable';

export default {
  name: 'BaseCell',
  mixins: [Hoverable],
  props: {
    condensed: {
      type: Boolean,
      default: false,
    },
    highContrast: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    customClass() {
      return {
        'base-cell--condensed': this.condensed,
        'base-cell--clickable': this.hasClickListener,
        'base-cell--high-contrast': this.highContrast,

      };
    },
    hasClickListener() {
      return this.$listeners.click || this.$listeners['!click'];
    },
  },
};
</script>

<style lang="scss" scoped>
.base-cell {
  min-height: 25px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  align-items: center;

  &--condensed {
    padding: 0.1rem 0!important;
  }

  &--clickable {
    cursor: pointer;
    transition: background 0.3s;
    &:hover {
      background-color: $gray-light;
    }
  }
  & + & {
    border-top: solid 1px $gray-light-4;
  }

  &--high-contrast + &--high-contrast{
    // This media query is for non-retina displays
    @media (-webkit-min-device-pixel-ratio: 1){
      border-top: solid 1px rgba($black, 0.5);
    }

    // This media query is for non-retina displays
    @media (-webkit-min-device-pixel-ratio: 2){

      /** Since in Chrome we don't have fraction of a pixel we are doing this hack for every browser */
      // this should be the right css border-top: solid 0.5px $black;
      // Meanwhile, the hack:
      border-top: none;
      position: relative;
      &:before{
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        position: absolute;
        top: 0;
        background-image: linear-gradient(to bottom, $black 0%, $black 51%, transparent 51%);
        background-size: 100% 1px;
      }
    }
  }
}
</style>
